import { get } from './request';

// 获取活动样式配置
export var getActivityConfig = function getActivityConfig(data) {
  return get('/question_active/active_img', data);
};